module.exports = __webpack_public_path__ + "img/carrousel-rad-conv-7.aa515b13.png";